import * as React from "react";
import { renderLeague, renderTeam } from "../../../EventCard/RenderMethods";
import { Event } from "../../../../../../contracts";

export const renderEventTeamsMultiview = (event: Event,componentPrefix: string, showLeagueInEventCard: boolean) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`} data-uat={`div-ev-list-${componentPrefix}-names`}>
        {renderLeague(showLeagueInEventCard, event.leagueName)}

        {renderTeam(event, event.isTeamSwap ? "2" : "1", componentPrefix)}
        {renderTeam(event, event.isTeamSwap ? "1" : "2", componentPrefix)}
    </div>